import { Flex, FormControl, FormErrorMessage, Icon, Select, SelectProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { BiLockAlt } from 'react-icons/bi';

import { FormInput } from './FormInput';
import { FormLabel } from './FormLabel';

export const FormSelect = ({
    fieldName,
    label,
    placeholder,
    isRequired = false,
    isReadOnly = false,
    labelWidth,
    children,
    onChange,
    ...selectProps
}: PropsWithChildren<
    {
        fieldName: string;
        label?: string;
        placeholder?: string;
        isRequired?: boolean;
        isReadOnly?: boolean;
        labelWidth?: string;
        onChange?: (data: any) => void;
    } & SelectProps
>) => {
    const {
        formState: { errors },
    } = useFormContext();

    if (isReadOnly) {
        return (
            <FormInput
                fieldName={fieldName}
                label={label}
                labelWidth={labelWidth}
                isRequired={isRequired}
                size={selectProps.size}
                isReadOnly
            />
        );
    }

    return (
        <FormControl
            isInvalid={!!errors[fieldName]}
            isRequired={isRequired}
            pointerEvents={isReadOnly ? 'none' : 'initial'}
        >
            <Flex direction="row" align="center">
                {label && <FormLabel fieldName={fieldName} labelWidth={labelWidth} label={label} />}
                <Controller
                    render={({ field: { onChange: onFieldChange, value } }) => (
                        <Select
                            variant={isReadOnly ? 'filled' : 'outline'}
                            placeholder={placeholder}
                            isReadOnly={isReadOnly}
                            icon={isReadOnly ? <Icon as={BiLockAlt} boxSize={10} /> : undefined}
                            iconSize="14px"
                            {...selectProps}
                            id={fieldName}
                            onChange={(ev) => {
                                onFieldChange(ev);
                                onChange?.(ev.target.value);
                            }}
                            value={value}
                        >
                            {children}
                        </Select>
                    )}
                    name={fieldName}
                />
            </Flex>
            {errors[fieldName] && <FormErrorMessage>{String(errors[fieldName]?.message)}</FormErrorMessage>}
        </FormControl>
    );
};
